import * as React from "react";

function MasoniteIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 119 28"
    >
      <defs>
        <clipPath>
          <rect width="119" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-masonite)">
        <path
          data-name="Path 7080"
          d="M-56.606-15.708V0h1.8V-12.5h.066L-49.3,0h1.628l5.434-12.5h.066V0h1.8V-15.708h-2.244l-5.83,13.4h-.066l-5.852-13.4Zm24.442,0L-38.346,0h1.936l1.672-4.4h7.216L-25.85,0h1.958l-6.182-15.708Zm-2,9.79,3.014-7.854h.088l2.97,7.854Zm17.578-10.1a6.991,6.991,0,0,0-4,1.056,3.583,3.583,0,0,0-1.738,3.19,3.321,3.321,0,0,0,1.8,3.036,26.294,26.294,0,0,0,3.608,1.276A18.875,18.875,0,0,1-13.6-6.314,2.55,2.55,0,0,1-12.034-4a2.225,2.225,0,0,1-1.188,1.98,5.97,5.97,0,0,1-3.124.726,5.057,5.057,0,0,1-3.19-.88,4.317,4.317,0,0,1-1.43-3.014h-1.782A5.6,5.6,0,0,0-20.7-.88,7.113,7.113,0,0,0-16.346.308,7.6,7.6,0,0,0-11.9-.858a3.815,3.815,0,0,0,1.65-3.256A3.706,3.706,0,0,0-12.21-7.436,21.171,21.171,0,0,0-16.3-8.954a18.282,18.282,0,0,1-2.882-.99,2.149,2.149,0,0,1-1.342-1.914,2.163,2.163,0,0,1,1.122-2,5.3,5.3,0,0,1,2.728-.572,4.59,4.59,0,0,1,2.97.836,3.966,3.966,0,0,1,1.32,2.53H-10.6a5.13,5.13,0,0,0-1.8-3.74A6.519,6.519,0,0,0-16.588-16.016Zm15.928,0A6.969,6.969,0,0,0-6.248-13.64,8.538,8.538,0,0,0-8.184-7.832,8.518,8.518,0,0,0-6.248-2.046,7.007,7.007,0,0,0-.682.308,7.053,7.053,0,0,0,4.906-2.046,8.589,8.589,0,0,0,6.842-7.832a8.669,8.669,0,0,0-1.936-5.83A6.968,6.968,0,0,0-.66-16.016Zm0,1.606a5.2,5.2,0,0,1,4.224,1.8A7.324,7.324,0,0,1,5.038-7.832,7.239,7.239,0,0,1,3.564-3.1,5.311,5.311,0,0,1-.682-1.3,5.209,5.209,0,0,1-4.928-3.146,7.187,7.187,0,0,1-6.38-7.832,7.209,7.209,0,0,1-4.928-12.54,5.234,5.234,0,0,1-.66-14.41Zm10.45-1.3V0h1.8V-12.914h.066L20.592,0H22.44V-15.708h-1.8V-2.926H20.57L11.682-15.708Zm16.39,0V0h1.782V-15.708Zm4.312,0v1.562h5.544V0h1.782V-14.146h5.544v-1.562Zm15.268,0V0H57.266V-1.562h-9.7V-7.326h8.8V-8.888h-8.8v-5.258h9.328v-1.562Z"
          transform="translate(57 22)"
          fill="#7fbe29"
        />
      </g>
    </svg>
  );
}

export default MasoniteIcon;
